module.exports = __webpack_public_path__ + "img/card-bg1@3x.abd909b0.png";